import { defineMessages } from 'react-intl';

export default defineMessages({
    pageTitle: {
        id: 'policy.view.policy-details.Policy Details',
        defaultMessage: 'Policy Details: {policyNumber}'
    },
    currentTab: {
        id: 'policy.view.policy-details.tab.Current',
        defaultMessage: 'Current'
    },
    changePolicy: {
        id: 'policy.view.policy-details.Change Policy',
        defaultMessage: 'Change Policy'
    },
    renewalTab: {
        id: 'policy.view.policy-details.tab.Renewing',
        defaultMessage: 'Renewing'
    },
    DownloadIDCard: {
        id: 'policy.view.policy-details.Download ID Card',
        defaultMessage: 'Download ID Card'
    },
    policyHolder: {
        id: 'policy.view.policy-details.Policy Holder',
        defaultMessage: 'Policy Holder'
    },
    effectiveDate: {
        id: 'policy.view.policy-details.Effective Date',
        defaultMessage: 'Effective Date'
    },
    expirationDate: {
        id: 'policy.view.policy-details.Expiration Date',
        defaultMessage: 'Expiration Date'
    },
    propCovCardHeader: {
        id: 'policy.view.policy-details.Property Information',
        defaultMessage: 'Property Information'
    },
    autoCovCardHeader: {
        id: 'policy.view.policy-details.Vehicle Information',
        defaultMessage: 'Vehicle Information'
    },
    boatCovCardHeader: {
        id: 'policy.view.policy-details.Boat Information',
        defaultMessage: 'Boat Information'
    },
    myAgent: {
        id: 'policy.view.policy-details.My Agent',
        defaultMessage: 'My Agent'
    },
    myBroker: {
        id: 'policy.view.policy-details.My Broker',
        defaultMessage: 'My Broker'
    },
    na: {
        id: 'policy.view.policy-details.Not available',
        defaultMessage: 'Not available'
    },
    importantNoteTitle: {
        id: 'policy.view.policy-details.Important Note',
        defaultMessage: 'Important Note'
    },
    importantNote: {
        id: 'policy.view.policy-details.Important Note Message',
        defaultMessage: 'The information in this portal will only show some of the information about your policy. If you have any questions about your policy, please contact your agent or broker.'
    },
    policyImportantNote: {
        id: 'policy.view.policy-details.policyImportantNote',
        defaultMessage: 'This portal only shows some of the information about your policy. If you have any questions, please contact your Agent or Broker.'
    },
    umbrellaCovCardHeader: {
        id: 'policy.view.policy-details.Policy Information',
        defaultMessage: 'Policy Information'
    },
    farmCovCardHeader: {
        id: 'policy.view.policy-details.Residential Information',
        defaultMessage: 'Residential Information'
    },
    notesAuthor: {
        id: 'claim.view.policy-details.Author',
        defaultMessage: 'From'
    },
    notesDate: {
        id: 'claim.view.policy-details.Date / Time',
        defaultMessage: 'Date / Time'
    },
    notesSubject: {
        id: 'claim.view.policy-details.Subject',
        defaultMessage: 'Subject'
    },
    PolicyNotesContent: {
        id: 'policy.view.policy-details.Send Message',
        defaultMessage: 'Send Message'
    },
    policyNotesContent: {
        id: 'policy.view.policy-details.There are no messages associated with this policy.',
        defaultMessage: 'There are no messages associated with this policy.'
    },
    PolicyMessagesContent: {
        id: 'policy.view.policy-details.Messages',
        defaultMessage: 'Messages'
    },
    noteTabImportantNote: {
        id: 'policy.view.policy-details.Important Note Message- Note Tab',
        defaultMessage: 'PLEASE NOTE: Insurance coverage CANNOT be bound unless you speak directly with your licensed Ayr Farmers Mutual Insurance Agent or Broker. Sending a message or leaving a voicemail does not constitute insurance coverage as being in effect.'
    },
    newMessageSCreen: {
        id: "policy.view.policy-details.New Message",
        defaultMessage: "New Message"
    },
    messageTextBox : {
        id: "policy.view.policy-details.Message",
        defaultMessage: "Message"
    },
    getAutoDocText: {
        id: "policy.view.policy-details.getAutoDocText",
        defaultMessage: "Click here to see your Ontario Automobile Policy forms:"
    },
    lineLevelCov: {
        id: "policy.view.policy-details.lineLevelCov",
        defaultMessage: "Line Level Coverages"
    },
    policyLevelCov: {
        id: "policy.view.policy-details.policyLevelCov",
        defaultMessage: "Policy Level Coverages"
    },
    propBuildCovCardHeader: {
        id: 'policy.view.policy-details.Property Coverage and Building Information',
        defaultMessage: 'Property Coverage and Building Information'
    },
    notePIIDisclaimer: {
        id: "policy.view.policy-details.notePIIDisclaimer",
        defaultMessage: "Please do not enter any unnecessary personal information or sensitive personal information (including but not limited to Banking information, Driver's License, Health Card information, or other government identifiers). If additional information is required, you will be contacted by a company representative."
    },
    policyDetailsImportantNote: {
          id: 'policy.view.policy-details.policyDetailsImportantNote',
          defaultMessage: 'This portal does not show all the information contained in your insurance declaration page. If you have any questions, please contact your Agent or Broker.”'
      }
});
